import * as React from "react";
import { format } from "VSS/Utils/String";
import { Icon } from "VSSUI/Icon";
import { TooltipHost, DirectionalHint } from "VSSUI/Tooltip";

import { ViewedStatus } from "VersionControl/Scenarios/PullRequestDetail/Stores/ViewedStore";
import { Flux } from "VersionControl/Scenarios/PullRequestDetail/View/PullRequestDetail.Flux";
import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";

export class ViewedFilesCounterContainer extends React.Component<{}, ViewedFilesCounterProps> {
    constructor(props: {}) {
        super(props);

        this.state = this._getStateFromStores();
    }

    public componentDidMount(): void {
        const { codeExplorerStore, viewedStore } = Flux.instance().storesHub;
        codeExplorerStore.addChangedListener(this.onStoresChanged);
        viewedStore.addChangedListener(this.onStoresChanged);
    }

    public componentWillUnmount(): void {
        const { codeExplorerStore, viewedStore } = Flux.instance().storesHub;
        codeExplorerStore.removeChangedListener(this.onStoresChanged);
        viewedStore.removeChangedListener(this.onStoresChanged);
    }

    public render(): JSX.Element {
        return <ViewedFilesCounter {...this.state} />;
    }

    private readonly onStoresChanged = () => {
        this.setState(this._getStateFromStores());
    }

    private _getStateFromStores(): ViewedFilesCounterProps {
        const { codeExplorerStore, viewedStore } = Flux.instance().storesHub;

        const iterationChanges = codeExplorerStore.getLatestIterationChanges();
        if (!iterationChanges || codeExplorerStore.getLatestIterationHasMoreChanges()) {
            return {
                totalCount: 0,
                viewedCount: 0,
            };
        }

        const viewedPaths = viewedStore.getFilePathsByStatus(iterationChanges, ViewedStatus.Viewed);

        return {
            totalCount: iterationChanges.changeEntries.length,
            viewedCount: viewedPaths.length,
        };
    }
}

export interface ViewedFilesCounterProps {
    viewedCount: number;
    totalCount: number;
}

/**
 * A viewed files counter for the pull request header.
 */
class ViewedFilesCounter extends React.Component<ViewedFilesCounterProps> {
    public render(): JSX.Element {
        const { viewedCount, totalCount } = this.props;
        if (!viewedCount || !totalCount) {
            return null;
        }

        const countText = format(VCResources.PullRequest_ViewedFilesCount, viewedCount, totalCount);
        const countTooltipText = format(VCResources.PullRequest_ViewedFilesCountTooltip, viewedCount, totalCount);

        return (
            <div className="vc-pullrequest-viewed-files-counter">
                <TooltipHost
                    content={countTooltipText}
                    directionalHint={DirectionalHint.bottomCenter}
                    calloutProps={{ gapSpace: 2 }}>
                    <span
                        tabIndex={0}
                        aria-label={countTooltipText}
                    >
                        <Icon iconName="Page" />
                        {countText}
                    </span>
                </TooltipHost>
            </div>
        );
    }
}
